"use client";
import React, { useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Text } from '@react-three/drei';
import * as THREE from 'three';
import Link from 'next/link';

function Scene() {
  const groupRef = useRef();
  const particlesRef = useRef();

  useEffect(() => {
    // Create and animate particles
    const particlesGeometry = new THREE.BufferGeometry();
    const particlesCount = 500;
    const positions = new Float32Array(particlesCount * 3);
    const colors = new Float32Array(particlesCount * 3);

    for (let i = 0; i < particlesCount * 3; i++) {
      positions[i] = (Math.random() - 0.5) * 20;
      colors[i] = Math.random();
    }

    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

    const particlesMaterial = new THREE.PointsMaterial({
      size: 0.1,
      vertexColors: true,
      transparent: true,
      opacity: 0.7,
    });

    const particles = new THREE.Points(particlesGeometry, particlesMaterial);
    particlesRef.current = particles;
    groupRef.current.add(particles);

    // Animation loop
    const animate = () => {
      if (particlesRef.current) {
        const positions = particlesRef.current.geometry.attributes.position.array;
        for (let i = 0; i < positions.length; i += 3) {
          positions[i + 1] += (Math.random() - 0.5) * 0.05;
          if (positions[i + 1] > 10) positions[i + 1] = -10;
        }
        particlesRef.current.geometry.attributes.position.needsUpdate = true;
      }
      requestAnimationFrame(animate);
    };
    animate();
  }, []);

  return (
    <group ref={groupRef}>
      <ambientLight intensity={0.5} />
      <pointLight position={[10, 10, 10]} intensity={1} />
      <Text
        fontSize={2}
        color="white"
        anchorX="center"
        anchorY="middle"
        position={[0, 0, 0]}
        rotation={[0, Math.PI / 4, 0]}
      >
        404
        <meshStandardMaterial color="orange" metalness={0.5} roughness={0.3} />
      </Text>
      <OrbitControls enableZoom={false} enablePan={false} autoRotate autoRotateSpeed={0.5} />
    </group>
  );
}

export default function Error404Component() {
  return (
    <div className="relative w-full h-screen overflow-hidden bg-black">
      <Canvas
        camera={{ position: [0, 0, 10], fov: 60 }}
        gl={{ antialias: true }}
        className="absolute top-0 left-0"
      >
        <fog attach="fog" args={['#1a1a2e', 10, 20]} />
        <Scene />
      </Canvas>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center z-10 text-white shadow-lg">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Oops! Page Not Found</h1>
        <Link href="/">
          <span className="inline-block px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-900 transition-colors">
            Return Home
          </span>
        </Link>
      </div>
      {/* <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center opacity-30"
        style={{ backgroundImage: "url('/images/bg.jpg')" }}
      ></div> */}
    </div>
  );
}